/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { t } from 'utils/translates';
import UserOutputCashHistoryTable from '../../../../../../components/UserOutputCash/UserOutputCashHistoryTable';
import UserOutputCashForm from '../../../../../../components/UserOutputCash/UserOutputCashForm';

class MyBalancePayOut extends Component {
  render() {
    return (
      <React.Fragment>
        <UserOutputCashForm />
        <div className="panel panel-default panel-heading_padding-large">
          <div className="panel-heading">
            <h2 className="panel-title text-center">
              <i className="fa fa-exchange fa-lg" />{' '}
              {t('История <strong>выплат</strong>')}
            </h2>
          </div>
          <div className="panel-body">
            <UserOutputCashHistoryTable {...this.props} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(MyBalancePayOut);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/MyBalance/MyBalancePayOut/MyBalancePayOut.js